/**
 * Tipuri partajate pentru versionarea fronturilor (Faza 4.5, spec-arhitectura §9,
 * spec-admin §2 Setări → Aplicație). Alimentează `/api/version`.
 */
/** Cele trei fronturi versionate independent. */
export const FRONTEND_APPS = ['client', 'admin', 'website'];
export function isFrontendApp(value) {
    return typeof value === 'string' && FRONTEND_APPS.includes(value);
}
/** Formă de versiune semver simplu X.Y.Z. */
export const SEMVER_PATTERN = '^\\d+\\.\\d+\\.\\d+$';
/** Compară două versiuni semver X.Y.Z. Întoarce -1 / 0 / 1. */
export function compareSemver(a, b) {
    const pa = a.split('.').map((n) => Number(n) || 0);
    const pb = b.split('.').map((n) => Number(n) || 0);
    for (let i = 0; i < 3; i++) {
        const d = (pa[i] ?? 0) - (pb[i] ?? 0);
        if (d !== 0)
            return d < 0 ? -1 : 1;
    }
    return 0;
}
//# sourceMappingURL=frontend.js.map